export const FETCH_MENU_ITEMS_SUCCESS = 'static/menuItems/FETCH_MENU_ITEMS_SUCCESS'
export const FETCH_MENU_ITEMS_FAILED = 'static/menuItems/FETCH_MENU_ITEMS_FAILED'
export const START_FETCHING = 'static/menuItems/START_FETCHING'
